module.exports = __webpack_public_path__ + "img/NO911986884.4b82e359.svg";